import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { SubscriptionProductService } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { RmaLetModule } from '@rma/dashboard/generic/ui/let';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { getCurrentRoute, setRedirectUrl } from '@rma/dashboard/generic/util/router-utils';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'rma-teams-callout-banner',
  imports: [AsyncPipe, MatButtonModule, TranslocoModule, StaticImageUrlPipe, RmaLetModule, RouterModule, RmaIconComponent],
  providers: [provideTranslocoScope('teamsBanner')],
  templateUrl: './teams-callout-banner.component.html',
  styleUrls: ['./teams-callout-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamsCalloutBannerComponent {
  @Input() name: string | null;
  @Input() cardFooter: boolean;

  protected readonly teamsQueryParams$: Observable<Params>;

  public readonly teamImage = 'promotion-banner/teams-callout/team-banner.png';
  public readonly teamUrl = 'https://go.ratemyagent.com/teams-contact-us';

  public readonly trialPeriodDays$: Observable<number>;
  public readonly showContactForm$: Observable<boolean>;
  public isDismissed = false;

  constructor(
    private readonly subscriptionProductService: SubscriptionProductService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.teamsQueryParams$ = this.route.queryParams.pipe(
      map((queryParams) => ({
        source: 'teams',
        ...setRedirectUrl(getCurrentRoute(this.router), queryParams),
      })),
    );

    this.trialPeriodDays$ = this.subscriptionProductService.teamAvailableTrialDays$;

    this.showContactForm$ = this.subscriptionProductService.teamSubscriptionProducts$.pipe(
      map((x) => !!x.filter((y) => y.ContactForPriceInformation === true).length),
    );
  }

  onClose() {
    this.isDismissed = true;
  }
}
